import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Auth0Provider } from "./react-auth0-spa";

import history from "./utils/history";

import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import thunk from "redux-thunk";

import counter from "./store/reducers/counter";
import user from "./store/reducers/user";
import api from "./store/reducers/api";
import qcApi from "./store/reducers/qcApi";
import report from "./store/reducers/reports";
import common from "./store/reducers/common";
import qcCommon from "./store/reducers/qcCommon";
import notifications from "./store/reducers/notifications";

// require('dotenv').config();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  counter: counter,
  user: user,
  api: api,
  report: report,
  common: common,
  qcApi: qcApi,
  qcCommon: qcCommon,
  notifications: notifications,
});

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

const onRedirectCallback = (appState) => {
  history.push(
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  );
};

ReactDOM.render(
  <Provider store={store}>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      client_id={process.env.REACT_APP_AUTH0_CLIENT_ID}
      redirect_uri={window.location.origin}
      onRedirectCallback={onRedirectCallback}
      audience={process.env.REACT_APP_AUTH0_AUDIENCE}
      mdo_login_connection={process.env.REACT_APP_AUTH0_LOGIN_CONNECTION}
      prompt={process.env.REACT_APP_PLATFORM_TYPE === "MARRIOTT" && process.env.REACT_APP_ENVIRONMENT === "PROD2" ? "none" : undefined}
    >
      <App />
    </Auth0Provider>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
